import { Button, Input, Modal } from "antd";
import React, { memo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ROUTES } from "../../utilities/Constants/Constants";
import ProceedSemantic from "../SemanticModel/ProceedFromSemanticQuery";
import "./styles.css";
import { useQueryTablesDataContext } from "../../context/QueryBuilder/QueryTablesDataContext";
import ResetQueriesModal from "./ResetQueriesModal";
import SelectAllButton from "./SelectAllButton";

const SemanticTopBar = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const { handleOnSearchTextChange } = useQueryTablesDataContext();

  const navigateToQueryList = () => {
    navigate(ROUTES.QUERYLIST, {
      state: {
        returnPath: location.pathname,
        returnSearch: location.search,
      },
    });
  };

  return (
    <div className="container m-0" style={{ maxWidth: "100%" }}>
      <div className="row align-items-center">
        <div className="col-2">
          <Input
            placeholder="/ Search tables"
            className="querybuilder-input"
            onChange={handleOnSearchTextChange}
          />
        </div>

        <div className="col d-flex justify-content-center">
          <div className="d-inline-flex align-items-center gap-1 actions-wrapper">
            <Button
              className="querybuilder-btn-default"
              onClick={navigateToQueryList}
            >
              View Models
            </Button>
            <div className="btn-divider mx-1"></div>
            <div className="d-flex gap-2 align-items-center justify-content-center">
              <ProceedSemantic />
            </div>
          </div>
        </div>

        <div className="col-2 d-flex justify-content-end">
        <div className="d-inline-flex align-items-center gap-2 actions-wrapper">
          <SelectAllButton />
          <ResetQueriesModal />
        </div>
        </div>
      </div>
    </div>
  );
};

export default memo(SemanticTopBar);
